import {
	HttpContextToken,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, finalize } from "rxjs";
import * as uuid from "uuid";
import { LoaderService } from "../providers/loader.service";

/**
 * Marca una petición como "silenciosa": no dispara el loader global de pantalla.
 * Para cargas decorativas/incrementales (p.ej. fotos de avatar) que no deben
 * bloquear la interacción. Uso: `{ context: new HttpContext().set(SKIP_GLOBAL_LOADER, true) }`.
 */
export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
	constructor(private readonly _loaderService: LoaderService) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		if (request.context.get(SKIP_GLOBAL_LOADER)) {
			return next.handle(request);
		}

		// Register request
		const requestId = uuid.v4();
		this._loaderService.register(requestId);

		return next.handle(request).pipe(
			finalize(() => {
				this._loaderService.unregister(requestId);
			}),
		);
	}
}
